import React from "react";

function Hero() {
  return (
    <div className="hero relative" id="home">
      <div className="app-container">
        {/* <div className="flex items-center h-[80vh]">
          <h1 className="text-4xl max-w-[100%] md:max-w-[800px] font-semibold leading-30 p-2 bg-[#0D1A3C] text-white">Your Dependable Independent Professionals</h1>
        </div> */}
      </div>
    </div>
  );
}

export default Hero;
